export default {
    elementIds: {
        almeInputIdNameBase: "conversation--input--alme-",
        almeMessageDisplayNameIdBase: "alme__message__displayname-",
        almeResponseIdNameBase: "conversation--response--alme-",
        endChatWarningTextId: "alme-window-end-chat-warning-text",
        skipToContentLink: "skip-to-content-link",
        skipToContentWrapper: "skip-to-content-wrapper",
        surveyNoIdNameBase: "survey--no--",
        surveyYesIdNameBase: "survey--yes--",
        timeoutWarningTextId: "alme-window-timeout-warning-text",
        userInputIdNameBase: "conversation--input--user-",
        userMessageDisplayNameIdBase: "user__message__displayname-",
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/element-ids.ts